/**
 * Tiny class joiner. Deliberately not `clsx` — this is the only thing we needed
 * from it, and a dependency for ten lines is not worth the install.
 */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ')
}
